// xss対策 sanitizeJsのデフォルト値

export const arrowCssProperty = [
  'font',
  'font-size',
  'font-weight',
  'font-style',
  'font-family',
  'text-decoration',
  'padding-left',
  'color',
  'background-color',
  'text-align',
  'width',
]

export const arrowTags = [
  {
    tag: 'p',
  },
  {
    tag: 'b',
  },
  {
    tag: 'i',
  },
  {
    tag: 'u',
  },
  {
    tag: 'strike',
  },
  {
    tag: 'span',
    attributes: ['style'],
  },
  {
    tag: 'font',
    attributes: ['style', 'color'],
  },
  {
    tag: 'a',
    attributes: ['href', 'title', 'target'],
  },
  {
    tag: 'strong',
  },
  {
    tag: 'ul',
  },
  {
    tag: 'ol',
  },
  {
    tag: 'li',
  },
  {
    tag: 'br',
  },
  {
    tag: 'img',
    attributes: ['style', 'src', 'data-filename'],
  },
]
